import axios from "axios";
import React, { useState, useContext, useEffect } from "react";
import AdminMasterLayout from "../../../layout/admin/AdminMasterLayout";
import { Container, Table, Button, Badge, Form } from "react-bootstrap";
import AppContext from "../../../context/AppContext";
import { Spinner } from "react-bootstrap";
const CategoriesInAdmin = () => {
  const { baseUrl, regTpChecker } = useContext(AppContext);
  const [btnLabel, setBtnLabel] = useState("Save Category");
  const [idToUploadDeleteCategory, setIdToUpdateDeleteCategory] = useState("");
  const [status, setStatus] = useState("Active");
  const [categoryRecord, setCategoryRecord] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [addUploadLoading, setAddUploadLoading] = useState(false);
  const [categoryName, setCategoryName] = useState("");
  const [categoryStatus, setCategoryStatus] = useState();
  const [showForm, setShowForm] = useState(true);
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);

  //---------------------------ADD
  const addCategory = () => {
    const formData = new FormData();
    formData.append("categoryName", categoryName);
    formData.append("status", status);
    console.log(formData);
    axios
      .post(`${baseUrl}/admin/tpcategory/addCategory`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        console.log(response.data);
        if (response.data.success == true) {
          setAddUploadLoading(false);
          setCategoryName("");
          viewAllUploadedCategories();
        }
      })
      .catch((error) => {
        console.log(error);
        setAddUploadLoading(false);
      });
  };
  //---------------------------Update
  const updateCategory = () => {
    const formData = new FormData();
    formData.append("id", idToUploadDeleteCategory);
    formData.append("categoryName", categoryName);

    axios
      .post(`${baseUrl}/admin/tpcategory/updateCategory`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        console.log(response.data);
        viewAllUploadedCategories();
        setCategoryName("");
        setAddUploadLoading(false);
        setBtnLabel("Save Category");
      })
      .catch((error) => {
        console.log(error);
        setAddUploadLoading(false);
      });
  };

  //---------------------Delete
  const deleteCategory = (idToDelete) => {
    const formData = new FormData();
    formData.append("id", idToDelete);

    axios
      .post(`${baseUrl}/admin/tpcategory/deleteCategory`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        console.log(response.data);
        viewAllUploadedCategories();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const viewAllUploadedCategories = () => {
    axios
      .get(`${baseUrl}/admin/tpcategory/viewAllUploadedCategories`)
      .then((response) => {
        console.log("DATA FROM API:", response.data); // 👈 ADD THIS
        setCategoryRecord(response.data.categoryRecords);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  //--------------- toggleStatus
  const toggleStatus = (id, currentStatus) => {
    const formData = new FormData();
    formData.append("id", id);
    formData.append(
      "status",
      currentStatus === "Active" ? "De-active" : "Active",
    );

    axios
      .post(`${baseUrl}/admin/tpcategory/updateCategoryStatus`, formData)
      .then((response) => {
        viewAllUploadedCategories(); // refresh table
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    viewAllUploadedCategories();
  }, []);

  return (
    <AdminMasterLayout>
      <Container className="py-4 shadow-lg rounded">
        <div className="d-flex justify-content-between mb-4">
          <h4>Categories Management</h4>
        </div>
        {/* Error Message */}
        {errorMessage && (
          <div className="buyer-error-message">{errorMessage}</div>
        )}

        {showForm && (
          <Form className="mb-4 border p-3 rounded">
            <Form.Group className="mb-3">
              <Form.Label>Category Name</Form.Label>
              <Form.Control
                value={categoryName}
                onChange={(e) => {
                  setCategoryName(e.target.value);
                  setErrorMessage(regTpChecker("category", e.target.value));
                }}
              />
            </Form.Group>

            {addUploadLoading ? (
              <Spinner />
            ) : (
              <Button
                disabled={!categoryName.trim() || errorMessage}
                onClick={() => {
                  console.log("Button clicked");
                  setAddUploadLoading(true);

                  if (btnLabel === "Save Category") {
                    addCategory();
                  } else {
                    updateCategory();
                  }
                }}
              >
                {btnLabel}
              </Button>
            )}
          </Form>
        )}

        <Table bordered hover responsive className="text-center">
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {categoryRecord.map((cat, index) => (
              <tr key={cat.id}>
                <td>{index + 1}</td>
                <td>{cat.categoryName}</td>
                <td>
                  <Badge bg={cat.status === "Active" ? "success" : "danger"}>
                    {cat.status}
                  </Badge>
                </td>
                <td>
                  <Button
                    size="sm"
                    variant="info"
                    onClick={() => {
                      setShowForm(true);
                      setIdToUpdateDeleteCategory(cat.id);
                      setBtnLabel("Update Category");
                      setCategoryName(cat.categoryName);
                    }}
                  >
                    Edit
                  </Button>
                  <Button
                    className="mx-2"
                    size="sm"
                    variant="danger"
                    onClick={() => deleteCategory(cat.id)}
                  >
                    Delete
                  </Button>
                  {/* <Button
                    size="sm"
                    variant="warning"
                    onClick={() => deleteCategory(cat.id)}
                  >
                    {cat.status === "Active" ? "De-active" : "Active"}
                  </Button> */}

                  <Button
                    size="sm"
                    variant="warning"
                    onClick={() => toggleStatus(cat.id, cat.status)}
                  >
                    {cat.status === "Active" ? "De-active" : "Active"}
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Container>
    </AdminMasterLayout>
  );
};

export default CategoriesInAdmin;
